import {
  Conditional,
  ConnectedCurrentUserAvatar,
  openDrawer,
} from '@opallabs/kuiper'
import { SectionHeading } from '@opallabs/lapidary'
import * as styles from './styles'

type ConfigurationHeaderProps = {
  primaryActionNode?: React.ReactNode
  secondaryActionNode?: React.ReactNode
  title: string
}

export const ConfigurationHeader = ({
  primaryActionNode,
  secondaryActionNode,
  title,
}: ConfigurationHeaderProps): JSX.Element => (
  <div css={styles.container}>
    <div css={styles.left} />

    <div css={styles.center}>
      <SectionHeading level={2}>{title}</SectionHeading>
    </div>

    <div css={styles.right}>
      {secondaryActionNode}
      {primaryActionNode}

      <Conditional condition={window.embedded}>
        <ConnectedCurrentUserAvatar
          size={32}
          onClick={(): void => openDrawer('darwin')}
        />
      </Conditional>
    </div>
  </div>
)
